export const tryToLoadDebugger = (Vue_: any) => {
  const Vue = Vue_;
  if (location.href.indexOf('isZtDebug=1') > -1) {
    const vconsole = document.createElement('script');
    vconsole.src = '//unpkg.com/vconsole/dist/vconsole.min.js';
    vconsole.addEventListener('load', () => {
      if (!window.VConsole) {
        return;
      }

      const { VConsole } = window;
      // 日志导出插件
      const exportLogPlugin = new VConsole.VConsolePlugin('export_log', '日志导出插件');
      exportLogPlugin.on('ready', () => {
        console.log('日志导出插件 ready');
      });
      exportLogPlugin.on('renderTab', (callback: Function) => {
        callback('<div class="vconsole-export-log"></div>');
      });
      exportLogPlugin.on('addTool', (callback: Function) => {
        callback([{
          name: '复制日志到剪贴板',
          onClick() {
            const content = `活动日志: \n${Array.from(document.querySelectorAll('.vc-log-val')).map(item => item.textContent)
              .join('\n')}`;
            Vue.prototype.tvfJsapi?.invoke('copyToClipBoard', { content }).then((res: any) => {
              if (res.errCode === 0) {
                alert('复制成功');
              }
            });
          },
        }]);
      });


      const vConsole = new VConsole({
        onReady: () => {
          window.setTimeout(() => {
            console.log('vConsole is ready');
          });
        },
      });

      vConsole.setOption('log.maxLogNumber', 5000);
      vConsole.setOption('log.maxNetworkNumber', 5000);

      vConsole.addPlugin(exportLogPlugin);
    });
    document.head.appendChild(vconsole);
  }
};
